import React, { FC } from 'react';

import styles from './label.module.css';

interface ILabelProps {
  label: string;
  required?: boolean;
}

export const Label: FC<ILabelProps> = ({ label, required }) => (
  <div className={styles.text}>
    <span>{label}</span>
    {!!required && <span className={styles.asterisk}>*</span>}
  </div>
);
